import { Store } from '@ngrx/store';
import { TrInputComponent } from './../tr-input/tr-input.component';
import { Component, OnInit, Input, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { StorageService } from '../../../services/storage.service';
import { AppState } from '../../../interfaces/app-state.interface';

@Component({
    selector: "tr-text",
    templateUrl: "./tr-text.component.html",
    styleUrls: ["./tr-text.component.scss"],
})
export class TrTextComponent extends TrInputComponent {
    public webApp;
    @Input() public maxLength = "100";
    @Input() public ttext = "";
    @Input() clickEvent: (args: any) => void;
    @Input() mouseEnterEvent: (args: any) => void;
    @ViewChild("formInput", { static: true }) public formInput: ElementRef;

    constructor(private render: Renderer2, store: Store<AppState>) {
        super(store);
        this.webApp = StorageService.getCookie("webapp") === "true";
    }
}
